import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=211331e6&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=211331e6&prod&lang=scss&scoped=true"
import style1 from "./Purchase.vue?vue&type=style&index=1&id=211331e6&prod&lang=scss"
import style2 from "./Purchase.vue?vue&type=style&index=2&id=211331e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211331e6",
  null
  
)

export default component.exports